export default __webpack_public_path__ + "static/media/airstrapz-bpk-banner-1.ebfe8225.jpg";